module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-precomposed-76e8739d88643a7c9ff0889547a96f30.png";